import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function ExpertQuote() {
  return <section className="w-full py-16 px-4 md:px-8 max-w-3xl mx-auto" data-id="element-78">
      <motion.div className="relative bg-forest-green text-white p-8 md:p-10 rounded-2xl shadow-lg" initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} data-id="element-79">
        <Quote className="absolute top-6 left-6 text-white/20 w-16 h-16 rotate-180" data-id="element-80" />

        <div className="relative z-10" data-id="element-81">
          <p className="text-xl md:text-2xl font-serif leading-relaxed italic mb-6" data-id="element-82">
            "Nach einer Darm-OP ist die Regeneration der Schleimhaut und der
            Darmflora entscheidend. Präbiotika und schützende Ballaststoffe
            können diesen Prozess natürlich und sanft unterstützen – immer in
            Absprache mit dem behandelnden Tierarzt."
          </p>

          <div className="flex items-center gap-4" data-id="element-83">
            <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center" data-id="element-84">
              <span className="font-bold text-xl" data-id="element-85">NS</span>
            </div>
            <div data-id="element-86">
              <p className="font-bold text-lg" data-id="element-87">Dr. Nane Schomburg</p>
              <p className="text-white/80 text-sm" data-id="element-88">Tierärztin</p>
            </div>
          </div>
        </div>
      </motion.div>
    </section>;
}